var _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrance2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.59,
    height: 25.92,
    viewBox: "0 0 27.59 25.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5.13 2.04 0 15 8.66 25.93 17.16 12.96 5.13 2.04",
    fill: "#abc4ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "27.59 10.93 22.45 23.89 8.66 25.93 13.79 12.96 19.76 9.67 27.59 10.93",
    fill: "#c4d6ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "13.79 12.96 20.91 11.91 27.59 10.93 18.93 0 5.13 2.04 13.79 12.96",
    fill: "#dde7ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance2);
export default __webpack_public_path__ + "static/media/entrance_2.8110992c464166c7480743e8963315a3.svg";
export { ForwardRef as ReactComponent };